import { FC } from "react";
import { Feedback } from "../../../../../common/store/chat/contants/feedback";
import ThumbUpIcon from "../../../../components/icons/thumb-up";
import ThumbDownIcon from "../../../../components/icons/thumb-down";
import styled from "styled-components";
import FeedbackIcon from "../../../../components/icons/feedback-icon";

const Item = styled.div`
  border-radius: 50%;
  background: #F8F8F8;
  width: 28px;
  height: 28px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  svg {
    path {
      fill: ${(props) => props.theme.themeConfig.primaryColor};
    }
  }
`

const Container = styled.div`
  position: absolute;
  bottom: -8px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  z-index: 1;
`

const CurrentFeedback: FC<{ mode?: Feedback, feedback?: string}> = ({ mode, feedback }) => {
  return (
    <Container className="voa_current_feedback">
      {mode && (
        <Item>
          {mode === Feedback.THUMB_UP
            ? <ThumbUpIcon isActive />
            : <ThumbDownIcon isActive />
          }
        </Item>
      )}
      {feedback && (
        <Item>
          <FeedbackIcon />
        </Item>
      )}
    </Container>
  )
}



export default CurrentFeedback